module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.attributes), function(attribute) {
    return _c('div', {
      staticClass: "col-lg-2 col-md-2 attribute-placeholder"
    }, [_c('label', [_c('span', [_vm._v(_vm._s(attribute.name))]), _vm._v(" "), (attribute.type === 2 && !attribute.ui_type && attribute.value) ? _c('span', {
      staticClass: "attribute-number-value"
    }, [_vm._v("\n                :   (" + _vm._s(attribute.value[0]) + " - " + _vm._s(attribute.value[1]) + ")\n            ")]) : _vm._e()]), _vm._v(" "), (attribute.type === 1) ? _c('multiselect', {
      attrs: {
        "placeholder": _vm.t('Attributes'),
        "options": attribute.values,
        "group-select": false,
        "label": "value",
        "maxHeight": 300,
        "custom-label": _vm.labelOption
      },
      on: {
        "input": function($event) {
          return _vm.onChangeText(attribute)
        }
      },
      model: {
        value: (attribute.value),
        callback: function($$v) {
          _vm.$set(attribute, "value", $$v)
        },
        expression: "attribute.value"
      }
    }, [_c('div', {
      attrs: {
        "slot": "noOptions"
      },
      slot: "noOptions"
    }, [_vm._v(_vm._s(_vm.t('List is empty')))])]) : _vm._e(), _vm._v(" "), (attribute.type === 2 && attribute.ui_type === 4) ? _c('multiselect', {
      attrs: {
        "placeholder": _vm.t('Attributes'),
        "options": attribute.options,
        "group-select": false,
        "track-by": 'name',
        "label": "name",
        "maxHeight": 300,
        "custom-label": _vm.labelOption
      },
      on: {
        "input": function($event) {
          return _vm.onChangeText(attribute)
        }
      },
      model: {
        value: (attribute.value),
        callback: function($$v) {
          _vm.$set(attribute, "value", $$v)
        },
        expression: "attribute.value"
      }
    }, [_c('div', {
      attrs: {
        "slot": "noOptions"
      },
      slot: "noOptions"
    }, [_vm._v(_vm._s(_vm.t('List is empty')))])]) : _vm._e(), _vm._v(" "), (attribute.type === 2 && !attribute.ui_type) ? _c('div', {
      staticClass: "form-inline form-group controls"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (attribute.value[0]),
        expression: "attribute.value[0]"
      }],
      staticClass: "controls form-control price-range-input",
      attrs: {
        "type": "number",
        "min": attribute.range[0]
      },
      domProps: {
        "value": (attribute.value[0])
      },
      on: {
        "change": function($event) {
          return _vm.onChangeNumeric(attribute)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(attribute.value, 0, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (attribute.value[1]),
        expression: "attribute.value[1]"
      }],
      staticClass: "controls form-control price-range-input",
      attrs: {
        "type": "number",
        "max": attribute.range[1]
      },
      domProps: {
        "value": (attribute.value[1])
      },
      on: {
        "change": function($event) {
          return _vm.onChangeNumeric(attribute)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(attribute.value, 1, $event.target.value)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (attribute.type === 3) ? _c('div', [(attribute.type === 3) ? _c('toggle-button', {
      attrs: {
        "height": 25,
        "width": 70,
        "labels": _vm.getValueForBoolean(attribute),
        "sync": attribute.sync
      },
      on: {
        "change": function($event) {
          return _vm.onChangeBoolean(attribute)
        }
      },
      model: {
        value: (attribute.value),
        callback: function($$v) {
          _vm.$set(attribute, "value", $$v)
        },
        expression: "attribute.value"
      }
    }) : _vm._e()], 1) : _vm._e()], 1)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-57ff062f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductAttribute.vue
// module id = 1295
// module chunks = 2